import { Box, Disclaimer, StackView, Spacer, Checkbox } from '@telus-uds/components-web';
import ReactMarkdown from 'react-markdown';
import { useTranslation } from 'react-i18next';

import { mdDisclaimerCompsMapping } from '../../utils/md-components';

export const Disclaimers = ({ disclaimers, consents, setConsents }) => {
  const { i18n } = useTranslation();

  return (
    <Box top={2}>
      <StackView direction={'column'} tokens={{ alignItems: 'start', justifyContent: 'center' }}>
        {disclaimers.map((d) => (
          <>
            <StackView
              key={d.id}
              space={2}
              direction={'row'}
              tokens={{ alignItems: 'start', justifyContent: 'center' }}
            >
              {d.consentRequired && (
                <Checkbox
                  checked={consents[d.id] || false}
                  onChange={(checked) =>
                    setConsents((prev) => ({
                      ...prev,
                      [d.id]: checked,
                    }))
                  }
                />
              )}
              <Disclaimer>
                <ReactMarkdown components={mdDisclaimerCompsMapping}>{d.content[i18n.language]}</ReactMarkdown>
              </Disclaimer>
            </StackView>
            <Spacer space={3} />
          </>
        ))}
      </StackView>
    </Box>
  );
};
